

import React, { useEffect, useState, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import JoditEditor from "jodit-react"; // Import JoditEditor
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlogUpdate = ({ placeholder }) => {
    const { slug } = useParams(); // Get the post slug from the URL
    const [title, setTitle] = useState(""); // State for title
    const [url, setUrl] = useState(""); // State for slug
    const [keywords, setKeywords] = useState(""); // State for keywords
    const [description, setDescription] = useState(""); // State for description
    const [content, setContent] = useState(""); // State for content
    const [bannerImage, setBannerImage] = useState(null); // State for banner image
    const [existingBannerImage, setExistingBannerImage] = useState(""); // State for existing banner image
    const editor = useRef(null);

    const config = useMemo(
        () => ({
            readonly: false, // all options from https://xdsoft.net/jodit/docs/,
            placeholder: placeholder || 'Start typing...',
            height: 400,
        }),
        [placeholder]
    );

    // Fetch post data when the component mounts
    useEffect(() => {
        const fetchPost = async () => {
            try {
                const response = await axios.get(`https://kvch.in:859/api/post/${slug}`);
                // Fill in the fields with existing post data
                setTitle(response.data.title);
                setKeywords(response.data.keywords);
                setDescription(response.data.description);
                setContent(response.data.content);
                setUrl(response.data.url); // Set the slug
                setExistingBannerImage(response.data.banner_image); // Store existing image URL


            } catch (error) {
                console.error("Error fetching post", error);
            }
        };
        fetchPost();
    }, [slug]); // Use slug as a dependency

    // Function to handle form submission for updating a post
    const handleUpdate = async (e) => {
        e.preventDefault(); // Prevent default form submission
        try {
            let imageUrl = existingBannerImage; // Keep existing image URL by default

            if (bannerImage) {
                // Create FormData to upload the image
                const formData = new FormData();
                formData.append("bannerImage", bannerImage); // Append the banner image

                // Upload the image
                const imageResponse = await axios.post("https://kvch.in:859/api/upload", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                imageUrl = imageResponse.data.imageUrl; // Get the uploaded image URL
            }

            const postData = {
                url, // Use the updated state for slug
                title,
                keywords,
                description,
                content,
                bannerImage: imageUrl, // Use the new or existing image URL
            };

            // Update the post using backend
            await axios.put(`https://kvch.in:859/api/posts/${slug}`, postData);
            toast.success("Post updated successfully");
            // navigate('/'); // Redirect after successful update (you can change this)
        } catch (error) {
            console.error("Error updating post", error);
            alert("Failed to update post");
        }
    };

    return (
        <>
            <ToastContainer />
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <div className="container">
                <form onSubmit={handleUpdate}>
                    <div className="form-group">
                        <label>Title</label>
                        <input
                            className="form-control"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Keywords</label>
                        <input
                            className="form-control"
                            type="text"
                            value={keywords}
                            onChange={(e) => setKeywords(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            className="form-control"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Slug</label>
                        <input
                            readOnly
                            style={{ cursor: "not-allowed" }}
                            className="form-control"
                            type="text"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <label>Banner Image</label>
                        <input
                            className="form-control"
                            type="file"
                            onChange={(e) => setBannerImage(e.target.files[0])}
                        />
                        {existingBannerImage && (
                            <p>Existing Image: <img src={`https://kvch.in:859${existingBannerImage}`} alt="Current Banner" style={{ width: '100px', height: 'auto', marginTop: '1rem' }} /></p>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Content</label>
                        <JoditEditor
                            ref={editor}
                            tabIndex={1}
                            value={content}
                            config={config}
                            onChange={(newContent) => setContent(newContent)} // Handle content change
                        />
                    </div>
                    <button className="btn btn-success" type="submit">Update Post</button>
                </form>
            </div>
        </>
    );
};

export default BlogUpdate;
